import React from 'react';

import PropTypes from 'prop-types';

import { ArrowRotateIcon } from '@iris/react-icons/ArrowRotateIcon';
import { PhotosIcon } from '@iris/react-icons/PhotosIcon';
import { PlayCircleIcon } from '@iris/react-icons/PlayCircleIcon';

import { Button } from 'reaxl';

import tabTitles from './tabTitles';

function MediaNavigator({
    onSelectTab = () => { },
    isXs = false,
    hasSpin = false,
    photoCount = 0,
    videoCount = 0,
}) {
    const photoButtonLabel = `${photoCount} Photo${photoCount > 1 ? 's' : ''}`;

    const videoButtonLabel = `${videoCount} Video${videoCount > 1 ? 's' : ''}`;

    const renderSpinButton = hasSpin && (
        <Button
            bsStyle="text"
            className="margin-right-5"
            id="spin360-btn"
        >
            <ArrowRotateIcon
                className="iris-icon display-inline-block"
            />
            {' '}
            360° Tour
        </Button>
    );

    const renderVideoButton = videoCount > 0 && (
        <Button
            bsStyle="text"
            className="margin-right-5"
            onClick={() => onSelectTab(tabTitles.VIDEOS)}
        >
            <PlayCircleIcon
                className="iris-icon display-inline-block"
            />
            {' '}
            {videoButtonLabel}
        </Button>
    );

    const renderPhotoButton = photoCount > 0 && (
        <Button
            data-cmp="media-navigator-photo-button"
            bsStyle="text"
            onClick={() => onSelectTab(tabTitles.IMAGES, 0)}
        >
            <PhotosIcon
                className="iris-icon display-inline-block"
            />
            {' '}
            {photoButtonLabel}
        </Button>
    );

    return (
        <div className={`margin-top-2 ${isXs ? 'text-center' : ''}`}>
            {renderSpinButton}
            {renderVideoButton}
            {renderPhotoButton}
        </div>
    );
}

MediaNavigator.propTypes = {
    onSelectTab: PropTypes.func,
    isXs: PropTypes.bool,
    hasSpin: PropTypes.bool,
    photoCount: PropTypes.number,
    videoCount: PropTypes.number,
};

export default MediaNavigator;
